import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { GetStagedShipmentMetaResponse } from '../../core/api/lab.types';

export const getStagedShipmentMetaThunk = createAsyncThunk(
  'shipment/getStagedShipmentMeta',
  async (_, { rejectWithValue }: any) => {
    const response: GetStagedShipmentMetaResponse = await labApi.getStagedShipmentMeta();

    if (response.data?.getStagedShipmentMeta) {
      return response.data.getStagedShipmentMeta;
    }

    return rejectWithValue(response.errors);
  },
);
